<template>
    <div>
        <div
            id="page-container"
            class="h-screen overflow-auto bg-white dark:bg-gray-800">
            <HeaderFrontend />
            <ImpersonateBanner />
            <SystemBanner />
            <BaseSlideOver
                :header-color="'primary'"
                :title="slideOverStore.title ? $t(slideOverStore.title) : ''"
                :description="slideOverStore.description ? $t(slideOverStore.description) : ''"
                :model-value="slideOverStore.isSlideOverOpen"
                @update:modelValue="slideOverStore.setSlideOverOpen($event)"
                @close-slide-over="closeSlideOver">
                <Component :is="components[slideOverStore.component]" />
            </BaseSlideOver>
            <main>
                <ComingSoonPage
                    v-if="underConstruction"
                    hide-dashboard-link />
                <div v-else>
                    <CmsFrontendAlert v-if="cmsEnabled" />

                    <slot />
                </div>
            </main>
            <FooterFrontend />
        </div>
    </div>
</template>

<script setup>
import FundingProgramsSelection from "@/components/global/FundingPrograms/FundingProgramsSelection"
import HeaderFrontend from "@/components/layouts/HeaderFrontend"
import AuthWrapper from "@/components/pages/auth/AuthWrapper.vue"
import {useNotification} from "@/composables/useNotification"
import {useAuthStore} from "@/store/auth"
import {useCmsNavItemsStore} from "@/store/cmsNavItems"
import {useSlideOverStore} from "@/store/slideOver"
import {useWebsocketStore} from "@/store/websockets"

const authStore = useAuthStore()
const slideOverStore = useSlideOverStore()
const route = useRoute()
const notification = useNotification()
const { t: $t } = useI18n()

const components = {
    FundingProgramsSelection,
    AuthWrapper,
}

const underConstruction = computed(() => useRuntimeConfig()?.public?.underConstruction)
const cmsEnabled = computed(() => useRuntimeConfig()?.public?.cmsEnabled)

onMounted(() => {
    if (route.query?.resetPassword === "true") {
        slideOverStore.setSlideOverOpen(true)
        slideOverStore.setTitle('auth.resetPassword')
        slideOverStore.setDescription('')
        slideOverStore.setComponent('AuthWrapper')
        slideOverStore.setContext(null)
        slideOverStore.setBeforeClosing(redirectToHome)
    }

    if (route.query?.verified == 1) {
        notification.success($t('auth.emailVerified'))
    }
    
    if (authStore.userData) {
        useWebsocketStore().init()
    }

    if (cmsEnabled.value) {
        useCmsNavItemsStore().fetchCmsNavItems()
    }
})

useHead({
    bodyAttrs: {
        class: 'h-full bg-gray-50'
    },
    htmlAttrs: {
        class: 'h-full'
    }
})

function redirectToHome() {
    navigateTo({path: '/', query: {}})
}

function closeSlideOver() {
    if (slideOverStore.beforeClosing && typeof slideOverStore.beforeClosing === 'function') {
        slideOverStore.beforeClosing()
    }

    slideOverStore.resetSlideOver()
}
</script>
